// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import dayjs from "dayjs";
import { isDefined, isEmpty, isUndefined } from "./check";
/**
* Generate a html id from the given string
*/
export const formatId = (name) => {
    return name.replace(/\./g, "_");
};
/**
 * Format a value to be sure we are displaying something
 * @param value
 * @returns
 */
export const formatValue = (value) => {
    return isUndefined(value) ? "n/a" : isEmpty(value) ? "Empty" : value;
};
/**
  * Insert a space before capitalized letter and change the dot to be a space
  * SuperTitle.name => Super Title name
  */
export const formatName = (name) => {
    return name.replace(/([A-Z])/g, " $1").replace(/\./g, " ");
};
/**
 * Display a unix timestamp in a proper readable format
 * @param unixdate a timestamp in seconds
 */
export const formatDate = (unixdate) => {
    return isDefined(unixdate) ? dayjs.unix(+unixdate).format("DD/MM/YYYY HH:mm") : "n/a";
};
/**
 * Display a JS timestamp in a proper readable format
 * @param pydate a timestamp in seconds
 */
export const formatTs = (ts) => {
    return isDefined(ts) ? dayjs(new Date(+ts)).format("DD/MM/YYYY HH:mm") : "n/a";
};
/**
 * Display the number as bytes
 * @param number
 * @returns
 */
export const formatBytes = (number) => {
    if (number < 1024) {
        return number + 'bytes';
    }
    else if (number >= 1024 && number < 1048576) {
        return (number / 1024).toFixed(1) + 'KB';
    }
    else if (number >= 1048576) {
        return (number / 1048576).toFixed(1) + 'MB';
    }
};
/**
 * Split the logs which are stored in a single line into multiple objects
 *  Build started#!1646397742.044898!# -> {text:'Build started', ts:1646397742.044898}
 * ts --> timestamp
 * @param build
 * @returns
 */
export const formatLogs = (build) => {
    const fullStringRegexp = /(.*?)#!([\d\.]*)!#/gm;
    if (isDefined(build.logs) && typeof build.logs == "string") {
        let m;
        const logs = [];
        while ((m = fullStringRegexp.exec(build.logs)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === fullStringRegexp.lastIndex) {
                fullStringRegexp.lastIndex++;
            }
            const messageRegex = /^(.*?)\s*\((.*?)\)$/;
            const match = m[1].match(messageRegex);
            if (match) {
                const event = match[1].trim();
                const ref = match[2].trim();
                logs.push({ text: m[1], event: event, ref: ref, ts: +m[2] });
            }
            else {
                logs.push({ text: m[1], ts: +m[2] });
            }
        }
        build.logs = logs;
    }
    return build;
};
